import { UntypedFormControl, Validators } from '@angular/forms';
import { emailValidator } from '@shared/validators/directives/email-validator.directive';

export function createForm(fb, data, config?) {
  const group = fb.group({});
  if (!!data.fieldset) {
    if (data.fieldset.length > 1) {
      // multiple fieldsets, multistep form
      data.fieldset.forEach(control => {
        const subGroup = fb.group({});
        control.field.forEach(subControl => {
          if (!!subControl.controlName) {
            subGroup.addControl(
              subControl.controlName,
              new UntypedFormControl('', Validators.required),
            );
          }
        });
        group.addControl(control.controlName, subGroup);
      });
    } else {
      data.fieldset[0].field.forEach(control => {
        if (!!control.controlName) {
          const validation = [];
          if (control.mandatory === 'true') {
            validation.push(Validators.required);
          }
          switch (control.inputType) {
            case 'email':
              validation.push(emailValidator);
              break;
            case 'number':
              validation.push(Validators.pattern('[0-9]+'));
              break;
            case 'text':
              validation.push(Validators.pattern('[a-zA-Z]+'));
              break;
          }

          group.addControl(
            control.controlName,
            new UntypedFormControl('', validation),
          );
        }
      });
    }
  }
  return group;
}
